<template>
  <span style="display: inline-block">
    <slot></slot>
  </span>
</template>

<script>
export default {};
</script>
